import React, {useEffect, useMemo} from "react";
import {EditorContent, EditorContext, useEditor} from "@tiptap/react";
import {StarterKit} from "@tiptap/starter-kit";
import {TextAlign} from "@tiptap/extension-text-align";
import {Underline} from "@tiptap/extension-underline";
import {Typography} from "@tiptap/extension-typography";
import ReviseTextButton from "../../../components/revise-text/revise-text-button";
import RichTextToolbar from "../../requests/components/RichTextToolbar";
import RichTextLinkExtension from "../../requests/components/RichTextLinkExtension";

const Observation = ({value, onChange, setIsLoading, disabled}) => {
    const editor = useEditor({
        immediatelyRender: false,
        editorProps: {
            attributes: {
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
            },
        },
        extensions: [
            StarterKit,
            TextAlign.configure({types: ["heading", "paragraph"]}),
            Underline,
            Typography,
            RichTextLinkExtension,
        ],
        content: value || "",
        onUpdate: ({editor: currentEditor}) => onChange(currentEditor.getHTML()),
    });

    const providerValue = useMemo(() => ({editor}), [editor]);

    useEffect(() => {
        if (!editor || value === editor.getHTML()) return;
        editor.commands.setContent(value || "", false);
    }, [editor, value]);

    useEffect(() => {
        editor?.setEditable(!disabled);
    }, [disabled, editor]);

    return (
        <div>
            <div>
                <EditorContext.Provider value={providerValue}>
                    <div className="text-editor">
                        {!disabled && <RichTextToolbar/>}
                        <div className="content-wrapper">
                            <EditorContent editor={editor} className="editor-content"/>
                        </div>
                    </div>
                </EditorContext.Provider>

                <div className="mt-4">
                    <ReviseTextButton
                        value={value}
                        setValue={(correctedValue) => onChange(correctedValue ?? "")}
                        setIsLoading={setIsLoading}
                        editor={editor}
                        module="candidates"
                        url="/api/si/candidates/text-correction"
                        disable={disabled}
                    />
                </div>
            </div>
        </div>
    );
};

export default Observation;
